import Honeybadger from '@honeybadger-io/js';
import { useEffect, useRef } from 'react';
import { Notice } from '@honeybadger-io/core/build/src/types';
import { configure } from '../utils/honeybadger';

type HoneybadgerExtras = Partial<Notice>;

export default function useHoneybadger() {
  const honeybadger = useRef<Honeybadger | null>(null);

  const notify = (error: Error | string, extras?: HoneybadgerExtras) => {
    honeybadger.current?.notify(error, extras);
  };

  useEffect(() => {
    honeybadger.current = configure();
  }, []);

  return { notify, honeybadgerRef: honeybadger };
}
